import BusinessLocationField from './BusinessLocationField.component';

export default BusinessLocationField;
